

<script>
    import Header from '@/Components/HomeComponents/Header.vue'
    import Footer from '@/Components/HomeComponents/Footer.vue'

    export default {
        components: {
            Header,
            Footer
        }
    }
</script>

<template>
        
    <!-- Main content -->
    <main class="p-2">
        <slot />
    </main>
    <Footer />
</template>
